import { useQuery } from "@tanstack/react-query";
import { UserService } from "@/services/userService";

// Query keys for users
export const userKeys = {
  all: ["users"] as const,
  allIncludingAdmins: ["users", "all"] as const,
  byId: (id: string) => ["users", id] as const,
};

// Get all users (excluding admins)
export function useUsers() {
  return useQuery({
    queryKey: userKeys.all,
    queryFn: UserService.getAllUsers,
  });
}

// Get all users including admins
export function useAllUsers() {
  return useQuery({
    queryKey: userKeys.allIncludingAdmins,
    queryFn: async () => {
      try {
        const result = await UserService.getAllUsersIncludingAdmins();
        return result;
      } catch (error) {
        console.error("❌ useAllUsers: Query failed", error);
        throw error;
      }
    },
    retry: 1,
    retryDelay: 1000,
  });
}

// Get user by ID
export function useUser(id: string) {
  return useQuery({
    queryKey: userKeys.byId(id),
    queryFn: () => UserService.getUserById(id),
    enabled: !!id,
  });
}
